import { render, staticRenderFns } from "./ppas.vue?vue&type=template&id=47de9fd5&"
import script from "./ppas.vue?vue&type=script&lang=js&"
export * from "./ppas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports